/*=========================================================================================
  File Name: usersActions.js
  Description: Vuex Store - users actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    getClientAcquisition({commit}, payload) {
        return new Promise((resolve, reject) => {
            let year_month = '';
            if(payload !== null){
                if(payload.from_year && payload.from_month && payload.to_year && payload.to_month){
                    year_month = '/' + payload.from_year + '/' + payload.from_month + '/' + payload.to_year + '/' + payload.to_month;
                } else {
                    year_month = '/' + payload.year + '/' + payload.month;
                }

            }

            axios({url: state.API_URL + '/auth/client-acquisition' + year_month, method: 'GET'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
};
